





























import { Component, Prop, Vue } from 'vue-property-decorator'
import { RestaurantPublic } from '@/services/Restaurants'
import Seatings from '@/services/Seatings'
import { getUserId } from '@/firebaseApp'
import Guests from '@/services/Guests'
import Loader from '@/components/global/loader.vue'
@Component({
  components: { Loader },
})
export default class CheckIn extends Vue {
  @Prop({ required: true }) public restaurant!: RestaurantPublic
  @Prop({ required: true }) public value!: string

  public name: string = this.value
  public accessCode: string = ''
  public restaurantId: string = ''
  public retrying: boolean = false
  public isLobbyFull: boolean = false

  async created() {
    this.restaurantId = this.$route.params.restaurantId
    this.accessCode = this.$route.params.accessCode

    // Check if the lobby is full
    await this.setLobbyState()
  }

  mounted() {
    const nameInput = this.$refs.nameInput as HTMLInputElement
    if (nameInput) {
      nameInput.focus()
    }
  }

  async saveName() {
    const userId = await getUserId()
    await Guests.updateName(this.restaurantId, this.accessCode, userId, this.name)
    this.$emit('input', this.name)
  }

  async setLobbyState() {
    this.isLobbyFull = await Seatings.isLobbyFull(this.restaurantId, this.accessCode)
  }

  async revisitLobby() {
    this.retrying = true
    setTimeout(async () => {
      await this.setLobbyState()
      this.retrying = false
    }, 500)
  }
}
